<template>
  <div>
    <PageAllow controller="PricingLogs" action="index" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                show-radios
                :radios="datetimeRadios"
                deleteIcon
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="order_code"
                    v-model="options.order_code"
                    @text="order_code = $event"
                    :label="$t('PricingLogs.Fields.order_code')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherMaterials v-model="materialSelected"/>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-sheet>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="logs"
          :options.sync="options"
          :loading="loading"
          mobile-breakpoint="800"
          multi-sort
          :page.sync="paging.page"
          :server-items-length="paging.count"
          class="elevation-2 px-4 pt-1"
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:item.order_code="{ item }">
            <a @click="$router.push('/orders/' + item.order_id)"
            >
              {{ item.order_code }}
            </a>
          </template>
          <template v-slot:item.Description="{ item }">
            {{ $t(settings ? settings.material_name_display_type == 4
                      ? "Material.nameWithCodeAndStandard"
                      : settings.material_name_display_type == 3
              ? "Material.materialNameWithCodeAndStandard"
                : settings.material_name_display_type == 2
                  ? "Material.materialNameWithCode"
                  : "Material.materialName"
              : "Material.materialName",
              [
                item.material.material_code,
                item.material.material_name,
                item.material.standard_name,
              ])
            }}
          </template>
          <template v-slot:item.before_price="{ item }">
            {{ item.before_price | formatMoney }}
          </template>
          <template v-slot:item.after_price="{ item }">
            {{ item.after_price | formatMoney }}
          </template>
          <template v-slot:item.created="{ item }">
            {{ item.created | formatTime }}
          </template>
        </v-data-table>
      </div>
    </v-sheet>
  </div>
</template>

<script>
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherMaterials from "@/components/plugins/SearcherMaterials";
import Logs from "@/api/logs";
import i18n from "@/i18n";
import {mapState} from "vuex";


const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
          new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
            .toISOString()
            .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  actual_time_from: "",
  actual_time_to: "",
  expect_time_from: "",
  expect_time_to: "",
  order_code: "",
  material_ids: [],
};

export default {
  data: () => ({
    options: JSON.parse(
      sessionStorage.getItem("orders-pricing-logs-options")
        ? sessionStorage.getItem("orders-pricing-logs-options")
        : JSON.stringify(defaultOptions)
    ),
    loading: false,
    order_code: "",
    materialSelected: [],
    logs: [],
    paging: {},
  }),

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.orderManagement"),
        disabled: false,
        replace: true,
        href: "/orders",
      },
      {
        text: i18n.t("Nav.ordersPricing"),
        disabled: false,
        href: "/orders-pricing",
      },
      {
        text: i18n.t("PricingLogs.title"),
        disabled: true,
        href: "/orders-pricing",
      },
    ],
    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("Order.Fields.created_time"),
      },
      {
        key: "actual",
        text: i18n.t("Order.Fields.actual_time"),
      },
      {
        key: "expect",
        text: i18n.t("Order.Fields.expect_date"),
      },
    ],
    headers: () => [
      {
        text: i18n.t("PricingLogs.Fields.order_code"),
        align: "start",
        sortable: false,
        value: "order_code",
      },
      {
        text: i18n.t("PricingLogs.Fields.material_name"),
        align: "start",
        sortable: false,
        value: "Description",
      },
      {
        text: i18n.t("PricingLogs.Fields.before_price"),
        align: "start",
        sortable: false,
        value: "before_price",
      },
      {
        text: i18n.t("PricingLogs.Fields.after_price"),
        align: "start",
        sortable: false,
        value: "after_price",
      },
      {
        text: i18n.t("PricingLogs.Fields.created"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("PricingLogs.Fields.operater"),
        align: "center",
        sortable: false,
        value: "creater_name",
      },
    ],
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    SearcherKeyword,
    SearcherMaterials,
  },

  mounted() {
    this.$commonUtils
      .loadOptions("orders-pricing-logs", [
        "materialSelected",
      ]).then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();
            data.selecteds.forEach((selected) => {
              switch (selected.key) {
                case "materialSelected":
                  this.materialSelected = selected.value;
                  break;
              }
            });
        }.bind(this)
    );
  },

  methods: {
    onSearch() {
      this.options = Object.assign({},this.options, {
        order_code: this.order_code,
      });
    },
    resetSearch() {
      this.materialSelected = [];
      [this.$refs.order_code].forEach((k) => {
        if (k) k.clear();
      });
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    getLogsFromAPI() {
      this.loading = true;
      Logs.getPricingLogs(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.logs = response.data.logs;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        sessionStorage.setItem("orders-pricing-logs-options", JSON.stringify(this.options));
        this.getLogsFromAPI();
      },
    },

    materialSelected: {
      handler() {
        this.options.material_ids = this.materialSelected
          ? this.materialSelected.map((e) => {
            return e.id;
          })
          : [];
        sessionStorage.setItem(
          "orders-pricing-logs-materialSelected",
          JSON.stringify(this.materialSelected)
        );
      },
    },
    
  },
};
</script>

<style>
</style>